import { all } from 'redux-saga/effects'
import SignIn from './SignInSaga'
import {
  FetchHomeOffersSaga,
  FetchUserDataSaga,
  FetchOffersSaga,
  FetchOfferSaga,
  ToggleLikedOfferSaga,
  CreateBetSaga,
  NewPasswordSaga,
  UpdatePasswordSaga,
  FetchConversationsSaga,
  FetchConversationSaga,
  UpdateProfileSaga,
  FetchInvoicesSaga,
  AcceptBuyNowContractSaga,
  UpdateSeenByDealerConversationSaga,
  TranslateTextSaga,
  RequestFullAccessSaga,
  SendPhoneConfirmationSaga,
  ConfirmPhoneSaga,
  FetchSpeditionsSaga
} from 'dealer-sagas'
import apiCall from 'src/helpers/apiCall'
import track, { type Events } from 'src/helpers/track'
import { CreateMessageSaga } from './CreateMessageSaga'
import ShowModal from './ShowModalSaga'
import CloseModal from './CloseModalSaga'
import UpdateProfilePassword from './UpdateProfilePasswordSaga'
import SignOut from './SignOutSaga'
import FetchPaginatedOffersSaga from './FetchPaginatedOffersSaga'
import CreateClientSaga from './CreateClientSaga'
import FetchClientsSaga from './FetchClientsSaga'
import UpdateClientSaga from './UpdateClientSaga'
import DeleteClientSaga from './DeleteClientSaga'
import FetchClientSaga from './FetchClientSaga'
import UpdateClientDetailsSaga from './UpdateClientDetailsSaga'
import FetchBrandsSaga from './FetchBrandsSaga'
import CreateMotorbikeSaga from './CreateMotorbikeSaga'
import FetchMotorbikesSaga from './FetchMotorbikesSaga'
import FetchMotorbikeSaga from './FetchMotorbikeSaga'
import UpdateMotorbikeSaga from './UpdateMotorbikeSaga'
import MarkMotorbikeAsSoldSaga from './MarkMotorbikeAsSoldSaga'
import DeleteMotorbikeSaga from './DeleteMotorbikeSaga'
import CreateInvoiceSaga from './CreateInvoiceSaga'
import FetchMarketplaceOffersSaga from './FetchMarketplaceOffersSaga'
import FetchMotorbikeModelsSaga from './FetchMotorbikeModelsSaga'
import CreateSellContractSaga from './CreateSellContractSaga'
import FetchSellContractInitialValues from './FetchSellContractInitialValues'
import UpdateSellContractSaga from './UpdateSellContractSaga'
import CreateImportDocumentSaga from './CreateImportDocumentSaga'
import FetchImportDocumentInitialValues from './FetchImportDocumentInitialValues'
import UpdateImportDocumentSaga from './UpdateImportDocumentSaga'
import FetchDocumentsSaga from './FetchDocumentsSaga'
import FetchDocumentPdfSaga from './FetchDocumentPdfSaga'
import DeleteDocumentSaga from './DeleteDocumentSaga'
import FetchInvoiceInitialValues from './FetchInvoiceInitialValues'
import UpdateInvoiceSaga from './UpdateInvoiceSaga'
import GetTokenSaga from './GetTokenSaga'
import IdentifyUserSaga from './IdentifyUserSaga'
import VerifyCaptchaSaga from './VerifyCaptchaSaga'
import FetchChannelsSaga from './FetchChannelsSaga'
import CreateChannelActivationSaga from './CreateChannelActivationSaga'
import SyncChannelActivationSaga from './SyncChannelActivationSaga'
import DeleteChannelActivationSaga from './DeleteChannelActivationSaga'
import CreateMobileListingSaga from './CreateMobileListingSaga'
import UpdateMobileListingSaga from './UpdateMobileListingSaga'
import FetchMobileListingsSaga from './FetchMobileListingsSaga'
import PauseMobileListingSaga from './PauseMobileListingSaga'
import DeleteMobileListingSaga from './DeleteMobileListingSaga'
import ResumeMobileListingSaga from './ResumeMobileListingSaga'
import FetchMobileReferenceValuesSaga from './FetchMobileReferenceValuesSaga'
import FetchMotorbikePhotosSaga from './FetchMotorbikePhotosSaga'
import CreateMotorbikePhotoSaga from './CreateMotorbikePhotoSaga'
import DeleteMotorbikePhotoSaga from './DeleteMotorbikePhotoSaga'

export function* rootSaga(): Generator {
  yield all([
    SignIn(),
    FetchUserDataSaga(apiCall),
    FetchHomeOffersSaga(apiCall),
    FetchOffersSaga(apiCall, (eventName, data) => {
      track(eventName as Events, data)
    }),
    ToggleLikedOfferSaga(apiCall),
    FetchOfferSaga(apiCall),
    CreateBetSaga(apiCall),
    NewPasswordSaga(apiCall),
    UpdatePasswordSaga(apiCall),
    FetchConversationsSaga(apiCall),
    FetchConversationSaga(apiCall),
    CreateMessageSaga(apiCall),
    UpdateProfileSaga(apiCall),
    FetchInvoicesSaga(apiCall),
    AcceptBuyNowContractSaga(apiCall),
    UpdateProfilePassword(),
    UpdateSeenByDealerConversationSaga(apiCall),
    ShowModal(),
    CloseModal(),
    SignOut(),
    TranslateTextSaga(apiCall),
    FetchPaginatedOffersSaga(),
    CreateClientSaga(),
    FetchClientsSaga(),
    UpdateClientSaga(),
    DeleteClientSaga(),
    FetchClientSaga(),
    UpdateClientDetailsSaga(),
    FetchBrandsSaga(),
    CreateMotorbikeSaga(),
    FetchMotorbikesSaga(),
    FetchMotorbikeSaga(),
    UpdateMotorbikeSaga(),
    MarkMotorbikeAsSoldSaga(),
    DeleteMotorbikeSaga(),
    CreateInvoiceSaga(),
    FetchMarketplaceOffersSaga(),
    FetchMotorbikeModelsSaga(),
    CreateSellContractSaga(),
    FetchSellContractInitialValues(),
    UpdateSellContractSaga(),
    CreateImportDocumentSaga(),
    FetchImportDocumentInitialValues(),
    UpdateImportDocumentSaga(),
    FetchDocumentsSaga(),
    FetchInvoiceInitialValues(),
    FetchDocumentPdfSaga(),
    DeleteDocumentSaga(),
    UpdateInvoiceSaga(),
    RequestFullAccessSaga(apiCall),
    SendPhoneConfirmationSaga(apiCall),
    ConfirmPhoneSaga(apiCall),
    FetchSpeditionsSaga(apiCall),
    GetTokenSaga(),
    IdentifyUserSaga(),
    VerifyCaptchaSaga(),
    FetchChannelsSaga(),
    CreateChannelActivationSaga(),
    SyncChannelActivationSaga(),
    DeleteChannelActivationSaga(),
    CreateMobileListingSaga(),
    UpdateMobileListingSaga(),
    FetchMobileListingsSaga(),
    PauseMobileListingSaga(),
    DeleteMobileListingSaga(),
    ResumeMobileListingSaga(),
    FetchMobileReferenceValuesSaga(),
    FetchMotorbikePhotosSaga(),
    CreateMotorbikePhotoSaga(),
    DeleteMotorbikePhotoSaga()
  ])
}
